import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Header from '../../../components/post-security/common/header';
import LessonsViewContent from './LessonsViewContent';

const PREFIX = 'LessonsView';

const classes = {
    rootGrid: `${PREFIX}-rootGrid`,
    header: `${PREFIX}-header`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.rootGrid}`]: {
        display: 'grid',
        height: '100vh',
        'gridTemplateRows': '48px auto',
        // overflowY: 'auto',
    },

    [`& .${classes.header}`]: {
        zIndex: 999999,
    }
}));

class LessonsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    // Locally changing settings

    componentDidMount() {
        document.title = "Lessons View";
    }

    render() {
        if (localStorage.getItem('ll_admin') !== 'true') {
            return <Navigate to="/ll/view" replace />;
        }

        const { } = this.props;

        return (
            <Root>
                <div className={classes.rootGrid}>
                    <div className={classes.header}>
                        {/* ***** Header Area ***** */}
                        <Header />
                    </div>
                    <div>
                        <LessonsViewContent 
                            getAccessTokenSilently = {this.props.auth}
                        />
                    </div>
                </div>
            </Root>
        );
    }
}

export default (LessonsView)